<template>
  <section class="infra-section">
    <img class="art-img" :src="introImg" alt="Infrastructure" />
    <div class="content">
      <div class="eyebrow">— {{ $t("home.v2.infrastructure.eyebrow") }}</div>
      <h2>
        {{ $t("home.v2.infrastructure.title") }}
        <span>{{ $t("home.v2.infrastructure.title2") }}</span>
      </h2>
      <p>
        {{ $t("home.v2.infrastructure.desc1") }}
      </p>
      <p>
        {{ $t("home.v2.infrastructure.desc2") }}
      </p>
      <button class="model-btn" @click="openExternal('https://about.rwa.ltd/consumer-rwa.html')">
        {{ $t("home.v2.infrastructure.button") }}
        <i class="el-icon-arrow-right" />
      </button>
    </div>
  </section>
</template>

<script>
export default {
  name: "InfrastructureSection",
  data() {
    return {
      // introImg: require("@/assets/img/images/home/introduction1-en.png"),
    };
  },
  computed: {
    // 简体/繁体中文使用中文图，其余语言使用英文图
    isZh() {
      const lan = this.$i18n.locale || "";
      return lan.indexOf("zh") === 0;
    },
    introImg() {
      const suffix = this.isZh ? "zh" : "en";
      return require("@/assets/img/images/home/introduction" +
          "-" +
          suffix +
          ".png");
    },
  },
  methods: {
    openExternal(url) {
      if (!url) return;
      window.open(url, "_blank");
    },
  },
};
</script>

<style lang="less" scoped>
.infra-section {
  width: 100%;
  background: #ffffff;
  box-sizing: border-box;
  position: relative;
  padding: 100px 60px;
  display: flex;
  justify-content: space-between;
  .art-img {
    width: 955px;
    height: 555px;
  }

  .content {
    flex: 1;
    margin-left: 30px;
    .eyebrow {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 18px;
      color: #333333;
    }
    h2 {
      line-height: 62px;
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: bold;
      font-size: clamp(32px, 2.75vw, 60px);
      color: #333333;
      margin-bottom: 16px;
      white-space: normal;
      word-break: break-word;
      overflow-wrap: break-word;
      span {
        color: #E05807;
      }
    }

    p {
      margin-bottom: 8px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 22px;
      color: #333333;
      white-space: normal;
      word-break: break-word;
      overflow-wrap: break-word;
    }
  }
}

.model-btn {
  margin-top: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 230px;
  height: 60px;
  padding: 0 24px;
  border: 1px solid #E05807;
  color: #E05807;
  font-size: 18px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  background: #ffffff;
  border-radius: 12px 12px 12px 12px;
  &:hover {
    background: rgba(215, 72, 72, 0.04);
  }
  i {
    font-size: 18px;
    margin-left: 8px;
  }
}
</style>
